/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { MomHeading } from '../Components/Sliders/MeditationSlider';

/** Styles */
/* Services */

/**
 * WhatisMom Component
 * @param {Object} section dato
 * @param {String} region
 * @param {String} lang
 * @returns {ReactElement} WhatisMom Component
 */
/**
 *
 * @param {Object} param0
 * @returns
 */
const WhatisMom = ({ section, region, lang }) => {
  const title = section.find(el => el._modelApiKey === 'section_title');
  const structured_text = section.find(
    el => el._modelApiKey === 'structured_text'
  );
  return (
    <Box
      my={{ base: '40px', md: '60px' }}
      pb={{ base: '30px', md: '60px' }}
      px={{ base: '16px' }}
    >
      <MomHeading text={title.titleText} maxW={400} py="40px" />
      <StructuredTextParser
        str={render(structured_text.body)}
        region={region}
        fontFamily="'Geist', sans-serif"
        maxW={'795px !important'}
        textAlign="center"
        lang={lang}
        fontSize={{ base: '16px', md: '28px' }}
        lineHeight={{ base: '24px', md: '48px' }}
        fontWeight={400}
        color="#535353"
        sx={{
          p: {
            marginBottom: '20px',
          },
        }}
      />
    </Box>
  );
};

export default WhatisMom;
